export const fr = {
    titreOnglet: "AccèsD Affaires | Desjardins"
};
